module.exports = __webpack_public_path__ + "img/hunter.4ce132dc.jpg";